// Robust geolocation helper. Requests a high-accuracy fix, retries with a
// coarser attempt, and returns a clear error code so the UI can guide the user.
export const acquireLocation = () => new Promise((resolve) => {
  if (!('geolocation' in navigator)) {
    resolve({ lat: null, lng: null, error: 'unsupported' });
    return;
  }
  const ok = (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy, error: null });
  const fail2 = (err) => {
    const code = err && err.code === 1 ? 'denied' : err && err.code === 3 ? 'timeout' : 'unavailable';
    resolve({ lat: null, lng: null, error: code });
  };
  // First try: high accuracy, fresh fix (no cache), generous timeout
  navigator.geolocation.getCurrentPosition(
    ok,
    () => {
      // Second try: coarser/faster fallback (still fresh)
      navigator.geolocation.getCurrentPosition(ok, fail2, { enableHighAccuracy: false, timeout: 20000, maximumAge: 0 });
    },
    { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 });
});

export const locHint = (error) => {
  switch (error) {
    case 'denied': return 'Location permission was blocked. Allow location for this site in your browser settings, then retry. Note: the in-app Preview window blocks GPS — open the site in Chrome or Safari (or use the live site) for verification.';
    case 'timeout': return 'Could not get a location fix in time. Make sure GPS/location is on, go outdoors if possible, then retry.';
    case 'unsupported': return 'This browser cannot share location. Please open the site in Chrome or Safari.';
    default: return 'Location is unavailable. Turn on GPS/location and retry. If you are in the in-app Preview window, open the site in Chrome or Safari instead.';
  }
};
